import { Alert, Badge, Box, Button, InfoIcon, Text } from '@razorpay/blade/components';
import { ESICRegistrationStatus } from 'api/employeeOnboarding';
import React from 'react';
import { prepareUrlV2 } from 'utils/Urls';
import { useUserId } from 'components/EmployeeDetails/BankAccountDetails/hooks/useUserId';
import { routePaths } from 'components/Routes/data';
import { PortalStatus } from '../types';
import { portalStatus } from '../data';

export const ESICRegistrationStatusInfo = ({
  esicRegistrationStatus,
  esicStatus,
}: {
  esicRegistrationStatus?: ESICRegistrationStatus;
  esicStatus?: PortalStatus | null;
}) => {
  const userId = useUserId();

  if (esicStatus === portalStatus.exit) {
    return (
      <Alert
        isDismissible={false}
        color="information"
        icon={InfoIcon}
        description="RazorpayX Payroll will mark employee Exit on ESIC portal automatically provided you execute employee's F&F month payroll"
      />
    );
  }

  if (esicStatus === portalStatus.notRegistered) {
    if (esicRegistrationStatus === 'Registration Failed') {
      return (
        <Box display="flex" gap="spacing.2" flexDirection="column" >
          <Text color="surface.text.gray.muted" weight="semibold">
            Registration Status
          </Text>
          <Badge icon={InfoIcon} color="negative">
            Failed
          </Badge>
          <Button
            marginTop="spacing.6"
            variant="secondary"
            href={routePaths.reports.esicRegistrationDashboard}
            target="_blank">
            ESIC Registration Report
          </Button>
        </Box>
      );
    }

    if (esicRegistrationStatus === 'Registration Pending') {
      return (
        <Box display="flex" gap="spacing.2" flexDirection="column">
          <Text color="surface.text.gray.muted" weight="semibold">
            Registration Status
          </Text>
          <Badge color="information">In Progress</Badge>
        </Box>
      );
    }

    return (
      <>
        <Alert
          isDismissible={false}
          color="negative"
          description="ESIC payments for this employee cannot be processed without completing their registration. Ensure registration is completed to avoid any compliance issues"
        />
        <Button
          variant="secondary"
          href={prepareUrlV2('/addEsi', {
            userId: userId,
          })}
          target="_blank">
          ESIC Registration
        </Button>
      </>
    );
  }

  return null;
};
